import { GLCodingData } from '../types/glCoding'

export const mockGLCodingData: GLCodingData = {
  separator: '-',
  dimensions: {
    Department: [
      { name: 'Department', code: '100', description: 'Finance' },
      { name: 'Department', code: '200', description: 'Operations' },
      { name: 'Department', code: '300', description: 'Sales' },
      { name: 'Department', code: '400', description: 'IT' },
      { name: 'Department', code: '500', description: 'Human Resources' },
      { name: 'Department', code: '600', description: 'Marketing' },
    ],
    'Cost Centre': [
      { name: 'Cost Centre', code: '1010', description: 'Accounting' },
      { name: 'Cost Centre', code: '1020', description: 'Treasury' },
      { name: 'Cost Centre', code: '2010', description: 'Manufacturing' },
      { name: 'Cost Centre', code: '2020', description: 'Logistics' },
      { name: 'Cost Centre', code: '3010', description: 'Direct Sales' },
      { name: 'Cost Centre', code: '3020', description: 'Channel Sales' },
      { name: 'Cost Centre', code: '4010', description: 'Infrastructure' },
      { name: 'Cost Centre', code: '4020', description: 'Applications' },
      { name: 'Cost Centre', code: '5010', description: 'Recruitment' },
      { name: 'Cost Centre', code: '5020', description: 'HR Operations' },
      { name: 'Cost Centre', code: '6010', description: 'Brand Marketing' },
      { name: 'Cost Centre', code: '6020', description: 'Digital Marketing' },
    ],
    Project: [
      { name: 'Project', code: 'P001', description: 'ERP Implementation' },
      { name: 'Project', code: 'P002', description: 'Digital Transformation' },
      { name: 'Project', code: 'P003', description: 'Product Launch Q1' },
      { name: 'Project', code: 'P004', description: 'Cost Optimization' },
      { name: 'Project', code: 'P005', description: 'Market Expansion' },
      { name: 'Project', code: 'P006', description: 'Infrastructure Upgrade' },
      { name: 'Project', code: 'BAU', description: 'Business As Usual' },
    ],
    Activity: [
      { name: 'Activity', code: 'A100', description: 'Salaries' },
      { name: 'Activity', code: 'A200', description: 'Consulting' },
      { name: 'Activity', code: 'A300', description: 'Software' },
      { name: 'Activity', code: 'A400', description: 'Hardware' },
      { name: 'Activity', code: 'A500', description: 'Travel' },
      { name: 'Activity', code: 'A600', description: 'Marketing' },
      { name: 'Activity', code: 'A700', description: 'Training' },
      { name: 'Activity', code: 'A800', description: 'Office Supplies' },
    ],
    Region: [
      {
        name: 'Region',
        code: 'NA-US',
        description: 'North America - United States',
      },
      { name: 'Region', code: 'NA-CA', description: 'North America - Canada' },
      { name: 'Region', code: 'EU-UK', description: 'Europe - United Kingdom' },
      { name: 'Region', code: 'EU-DE', description: 'Europe - Germany' },
      {
        name: 'Region',
        code: 'APAC-AU',
        description: 'Asia Pacific - Australia',
      },
      {
        name: 'Region',
        code: 'APAC-SG',
        description: 'Asia Pacific - Singapore',
      },
      { name: 'Region', code: 'GLOBAL', description: 'Global' },
    ],
  },
}
